export default "__VITE_ASSET__D4V0krzQ__"